// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 🌐 Base Styles */
body {
  margin: 0;
  font-family: "Poppins", sans-serif;
  background-color: #f4f4f4;
}

* {
  box-sizing: border-box;
}

/* 🔝 Navbar */
.navbar {
  background-color: #1f2937;
  padding: 5px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
  height: 50px;
}

.navbar .logo {
  color: white;
  font-size: 24px;
  font-weight: bold;
}

.nav_links {
  list-style: none;
  display: flex;
  gap: 20px;
  margin-left: auto;
  margin-right: 20px;
}

.nav_links li a {
  color: white;
  text-decoration: none;
  font-size: 18px;
  padding: 8px 12px;
  transition: background-color 0.3s ease;
}

.nav_links li a:hover {
  background-color: #2563eb;
  border-radius: 6px;
}

/* 🍔 Hamburger Menu Icon */
.menu-icon {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 24px;
  cursor: pointer;
  z-index: 1100;
}

.menu-icon span {
  height: 4px;
  background-color: white;
  border-radius: 4px;
  transition: all 0.3s ease-in-out;
}

/* Keep the hamburger simple (no rotated animation). */
.menu-icon.active span {
  opacity: 0.9;
}

/* 🔲 Content container */
.content {
  margin-top: 50px;
  margin-bottom: 40px;
  padding: 20px;
}

/* ✅ Reusable UI helpers */
.btn {
  background: #ffffff;
  border: 1px solid #d1d5db;
  padding: 10px 14px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 0.95rem;
  transition: transform 0.06s ease, background 0.2s ease;
}

.btn:hover {
  background: #f9fafb;
}

.btn:active {
  transform: translateY(1px);
}

.btn-primary {
  background-color: #2563eb;
  border-color: #2563eb;
  color: white;
}

.btn-primary:hover {
  background-color: #1d4ed8;
}

.btn-danger {
  background: #fee2e2;
  border-color: #fecaca;
  color: #991b1b;
}

.btn-danger:hover {
  background: #fecaca;
}

.muted {
  color: #6b7280;
}

/* 📚 Library page */
.library_wrapper {
  max-width: 1200px;
  margin: 0 auto;
}

.library_header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
}

.library_header h2 {
  margin: 0 0 6px;
}

.library_actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.search_box {
  display: flex;
  gap: 8px;
  align-items: center;
}

.search_box input {
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid #d1d5db;
  min-width: min(320px, 70vw);
}

.books_grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.book-card {
  background: #fff;
  border-radius: 14px;
  padding: 16px;
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.06);
  border: 1px solid #eef2f7;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 12px;
  min-height: 170px;
}

.book-meta h3 {
  margin: 0 0 4px;
  font-size: 1.05rem;
  color: #111827;
}

.book-link {
  text-decoration: none;
  color: #2563eb;
  font-weight: 600;
}

.book-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.pagination {
  margin-top: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.page_meta {
  color: #4b5563;
}

.empty_state {
  background: #fff;
  border: 1px dashed #d1d5db;
  padding: 22px;
  border-radius: 14px;
  text-align: center;
  color: #6b7280;
}

/* 🏠 Hero Slideshow */
.fullscreen-slideshow {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.slide {
  position: absolute;
  width: 100%;
  height: 100%;
  display: none;
  z-index: 1;
}

.slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.fade {
  animation-name: fade;
  animation-duration: 1.5s;
}

@keyframes fade {
  from {
    opacity: 0.4;
  }
  to {
    opacity: 1;
  }
}

.slide-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  text-align: center;
  color: white;
  padding: 20px;
}

.overlay-text {
  font-size: 2.5rem;
  font-weight: bold;
  text-shadow: 2px 2px 8px #000;
  max-width: 90%;
}

/* 📘 About Preview */
.about_preview {
  background-size: cover;
  background-position: top center;
  width: 100%;
  height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
  position: relative;
}

.overlay_box {
  text-align: center;
  background-color: rgba(0, 0, 0, 0.6);
  padding: 60px 20px;
  color: #fff;
  max-width: 700px;
  border-radius: 16px;
}

.overlay_box h3 {
  font-size: 2rem;
  margin-bottom: 20px;
}

.overlay_box p {
  font-size: 1.2rem;
  margin-bottom: 20px;
}

.btn-primary {
  background-color: #2563eb;
  color: white;
  padding: 12px 24px;
  font-size: 1rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.3s;
}

.btn-primary:hover {
  background-color: #1d4ed8;
}

/* 💡 Value Section */
.value_section {
  display: flex;
  justify-content: center;
  align-items: stretch;
  gap: 30px;
  padding: 60px 20px;
  background-color: #f9fafb;
  flex-wrap: wrap;
}

.value_card {
  background: white;
  padding: 30px;
  flex: 1;
  max-width: 300px;
  text-align: center;
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.05);
}

.value_card img {
  height: 50px;
  margin-bottom: 15px;
}

.value_card h4 {
  font-size: 1.25rem;
  margin-bottom: 10px;
  color: #1f2937;
}

.value_card p {
  font-size: 1rem;
  color: #4b5563;
}

/* 👤 Testimonials Section */
.testimonials_section {
  background-color: #fff;
  padding: 60px 20px;
  text-align: center;
}

.testimonials_section h3 {
  font-size: 2rem;
  margin-bottom: 40px;
  color: #1f2937;
}

.testimonial_cards {
  display: flex;
  gap: 30px;
  justify-content: center;
  flex-wrap: wrap;
}

.testimonial_card {
  background-color: #f3f4f6;
  padding: 30px;
  border-radius: 12px;
  max-width: 300px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.05);
  text-align: center;
}

.testimonial_card img {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  margin-bottom: 20px;
}

.testimonial_card p {
  font-size: 1rem;
  color: #374151;
  margin-bottom: 10px;
}

.testimonial_card h4 {
  font-size: 1rem;
  font-weight: bold;
  color: #1f2937;
}

/* 📘 About Page */
.about_page_container {
  background-color: #f3f4f6;
  padding: 80px 20px 100px;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.about_content_box {
  background-color: #ffffff;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
  max-width: 800px;
  text-align: center;
}

.about_content_box h1 {
  font-size: 2.5rem;
  color: #1f2937;
  margin-bottom: 20px;
}

.about_content_box p {
  font-size: 1.1rem;
  color: #4b5563;
  line-height: 1.8;
  margin-bottom: 20px;
}

/* 📥 Footer */
.footer {
  background: linear-gradient(to right, #111827, #1f2937);
  color: #ffffff;
  padding: 60px 20px 30px;
  font-size: 0.95rem;
}

.footer-columns {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 40px;
  max-width: 1200px;
  margin: auto;
}

.footer-about,
.footer-contact,
.footer-links {
  flex: 1;
  min-width: 250px;
}

.footer-about h3,
.footer-contact h4,
.footer-links h4 {
  color: white;
}

.footer-contact p,
.footer-about p,
.footer-links ul {
  margin: 5px 0;
  color: #d1d5db;
}

.footer-contact a {
  color: #3b82f6;
  text-decoration: none;
}

.footer-contact a:hover {
  text-decoration: underline;
}

.footer-links ul {
  list-style: none;
  padding: 0;
}

.footer-links li {
  margin: 5px 0;
}

.footer-links a {
  color: #9ca3af;
  text-decoration: none;
}

.footer-links a:hover {
  color: #ffffff;
  text-decoration: underline;
}

.footer-bottom {
  text-align: center;
  padding-top: 30px;
  border-top: 1px solid #374151;
  color: #9ca3af;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 0.95rem;
}
@media (max-width: 600px) {
  .footer-bottom {
    flex-direction: column;
    gap: 4px;
  }
}

/* 🔐 Auth Styling */
.auth_wrapper {
  min-height: 70vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f9fafb;
  padding: 40px 20px;
}

.auth_box {
  background-color: #ffffff;
  padding: 40px 30px;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
  text-align: center;
}

.auth_box h2 {
  font-size: 1.8rem;
  margin-bottom: 20px;
  color: #1f2937;
}

.input_group {
  margin-bottom: 16px;
}

.input_group input {
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 1rem;
  transition: border-color 0.3s ease;
}

.input_group input:focus {
  border-color: #2563eb;
  outline: none;
}

.input_group button {
  width: 100%;
  padding: 12px;
  font-size: 1rem;
  border: none;
  border-radius: 8px;
  background-color: #2563eb;
  color: white;
  cursor: pointer;
  transition: background-color 0.3s;
}

.input_group button:hover {
  background-color: #1d4ed8;
}

/* 📚 Library */
.library_wrapper {
  max-width: 1200px;
  margin: 0 auto;
}

.library_header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 18px;
}

.library_header h2 {
  margin: 0;
  color: #1f2937;
}

.muted {
  color: #6b7280;
  margin: 6px 0 0;
}

.library_actions {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}

.search_box {
  display: flex;
  gap: 8px;
  align-items: center;
}

.search_box input {
  height: 40px;
  padding: 0 12px;
  border-radius: 10px;
  border: 1px solid #d1d5db;
  min-width: min(420px, 78vw);
}

.btn {
  height: 40px;
  padding: 0 14px;
  border: 1px solid #d1d5db;
  background: #ffffff;
  border-radius: 10px;
  cursor: pointer;
  transition: transform 0.05s ease-in-out;
}

.btn:active {
  transform: translateY(1px);
}

.btn-primary {
  border: none;
  background: #2563eb;
  color: #ffffff;
}

.btn-danger {
  border: 1px solid #ef4444;
  color: #ef4444;
  background: #fff;
}

.books_grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
}

.book-card {
  background: #ffffff;
  border-radius: 14px;
  border: 1px solid #e5e7eb;
  padding: 16px;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 170px;
}

.book-meta h3 {
  margin: 0 0 6px;
  font-size: 1.15rem;
  color: #111827;
  line-height: 1.3;
}

.book-link {
  display: inline-block;
  margin: 10px 0 12px;
  color: #2563eb;
  text-decoration: none;
  font-weight: 600;
}

.book-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin: 18px 0 6px;
  flex-wrap: wrap;
}

.page_meta {
  color: #4b5563;
}

.empty_state {
  padding: 24px;
  border: 1px dashed #cbd5e1;
  background: #f8fafc;
  border-radius: 12px;
  text-align: center;
  color: #475569;
}

/* 🪟 Modal */
.modal {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 2000;
  padding: 20px;
}

.modal-content {
  width: min(640px, 96vw);
  margin: 70px auto 0;
  background: #fff;
  border-radius: 16px;
  padding: 22px;
  position: relative;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 14px;
  border: none;
  background: transparent;
  font-size: 26px;
  cursor: pointer;
}

.form label {
  display: block;
  margin: 10px 0 6px;
  color: #374151;
  font-weight: 600;
}

.form input,
.form textarea {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  padding: 12px;
  font-size: 1rem;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 16px;
  flex-wrap: wrap;
}

.thumbs-container {
  display: flex;
  gap: 10px;
  margin-top: 10px;
  flex-wrap: wrap;
}

.thumb.active {
  border-color: #2563eb;
  background: rgba(37, 99, 235, 0.08);
}

/* 📱 Responsive Styles */
@media (max-width: 768px) {
  .menu-icon {
    display: flex;
  }

  .nav_links {
    display: none;
    flex-direction: column;
    position: absolute;
    top: 50px;
    right: 0;
    background-color: #1f2937;
    width: 200px;
    padding: 15px 0;
    border-bottom-left-radius: 12px;
    z-index: 100;
  }

  .nav_links.active {
    display: flex;
  }

  .fullscreen-slideshow {
    height: 60vh;
  }

  .overlay-text {
    font-size: 1.8rem;
  }

  .overlay_box h3 {
    font-size: 1.5rem;
  }

  .overlay_box p {
    font-size: 1rem;
  }

  .testimonial_cards,
  .value_section {
    flex-direction: column;
    align-items: center;
  }

  .about_content_box h1 {
    font-size: 2rem;
  }

  .about_content_box p {
    font-size: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,SAAS;EACT,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,MAAM;EACN,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA,sDAAsD;AACtD;EACE,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,wBAAwB;EACxB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,uDAAuD;EACvD,cAAc;EACd,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,YAAY;AACd;;AAEA;;;EAGE,OAAO;EACP,gBAAgB;AAClB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;;;EAGE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE;IACE,sBAAsB;IACtB,QAAQ;EACV;AACF;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA,yBAAyB;AACzB;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,+BAA+B;IAC/B,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* 🌐 Base Styles */\nbody {\n  margin: 0;\n  font-family: \"Poppins\", sans-serif;\n  background-color: #f4f4f4;\n}\n\n* {\n  box-sizing: border-box;\n}\n\n/* 🔝 Navbar */\n.navbar {\n  background-color: #1f2937;\n  padding: 5px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  top: 0;\n  z-index: 1000;\n  height: 50px;\n}\n\n.navbar .logo {\n  color: white;\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.nav_links {\n  list-style: none;\n  display: flex;\n  gap: 20px;\n  margin-left: auto;\n  margin-right: 20px;\n}\n\n.nav_links li a {\n  color: white;\n  text-decoration: none;\n  font-size: 18px;\n  padding: 8px 12px;\n  transition: background-color 0.3s ease;\n}\n\n.nav_links li a:hover {\n  background-color: #2563eb;\n  border-radius: 6px;\n}\n\n/* 🍔 Hamburger Menu Icon */\n.menu-icon {\n  display: none;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 30px;\n  height: 24px;\n  cursor: pointer;\n  z-index: 1100;\n}\n\n.menu-icon span {\n  height: 4px;\n  background-color: white;\n  border-radius: 4px;\n  transition: all 0.3s ease-in-out;\n}\n\n/* Keep the hamburger simple (no rotated animation). */\n.menu-icon.active span {\n  opacity: 0.9;\n}\n\n/* 🔲 Content container */\n.content {\n  margin-top: 50px;\n  margin-bottom: 40px;\n  padding: 20px;\n}\n\n/* ✅ Reusable UI helpers */\n.btn {\n  background: #ffffff;\n  border: 1px solid #d1d5db;\n  padding: 10px 14px;\n  border-radius: 10px;\n  cursor: pointer;\n  font-size: 0.95rem;\n  transition: transform 0.06s ease, background 0.2s ease;\n}\n\n.btn:hover {\n  background: #f9fafb;\n}\n\n.btn:active {\n  transform: translateY(1px);\n}\n\n.btn-primary {\n  background-color: #2563eb;\n  border-color: #2563eb;\n  color: white;\n}\n\n.btn-primary:hover {\n  background-color: #1d4ed8;\n}\n\n.btn-danger {\n  background: #fee2e2;\n  border-color: #fecaca;\n  color: #991b1b;\n}\n\n.btn-danger:hover {\n  background: #fecaca;\n}\n\n.muted {\n  color: #6b7280;\n}\n\n/* 📚 Library page */\n.library_wrapper {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.library_header {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 18px;\n}\n\n.library_header h2 {\n  margin: 0 0 6px;\n}\n\n.library_actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.search_box {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.search_box input {\n  padding: 10px 12px;\n  border-radius: 10px;\n  border: 1px solid #d1d5db;\n  min-width: min(320px, 70vw);\n}\n\n.books_grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.book-card {\n  background: #fff;\n  border-radius: 14px;\n  padding: 16px;\n  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.06);\n  border: 1px solid #eef2f7;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 12px;\n  min-height: 170px;\n}\n\n.book-meta h3 {\n  margin: 0 0 4px;\n  font-size: 1.05rem;\n  color: #111827;\n}\n\n.book-link {\n  text-decoration: none;\n  color: #2563eb;\n  font-weight: 600;\n}\n\n.book-actions {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.pagination {\n  margin-top: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.page_meta {\n  color: #4b5563;\n}\n\n.empty_state {\n  background: #fff;\n  border: 1px dashed #d1d5db;\n  padding: 22px;\n  border-radius: 14px;\n  text-align: center;\n  color: #6b7280;\n}\n\n/* 🏠 Hero Slideshow */\n.fullscreen-slideshow {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  overflow: hidden;\n}\n\n.slide {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: none;\n  z-index: 1;\n}\n\n.slide img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.fade {\n  animation-name: fade;\n  animation-duration: 1.5s;\n}\n\n@keyframes fade {\n  from {\n    opacity: 0.4;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.slide-overlay {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 2;\n  text-align: center;\n  color: white;\n  padding: 20px;\n}\n\n.overlay-text {\n  font-size: 2.5rem;\n  font-weight: bold;\n  text-shadow: 2px 2px 8px #000;\n  max-width: 90%;\n}\n\n/* 📘 About Preview */\n.about_preview {\n  background-size: cover;\n  background-position: top center;\n  width: 100%;\n  height: 70vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 30px;\n  position: relative;\n}\n\n.overlay_box {\n  text-align: center;\n  background-color: rgba(0, 0, 0, 0.6);\n  padding: 60px 20px;\n  color: #fff;\n  max-width: 700px;\n  border-radius: 16px;\n}\n\n.overlay_box h3 {\n  font-size: 2rem;\n  margin-bottom: 20px;\n}\n\n.overlay_box p {\n  font-size: 1.2rem;\n  margin-bottom: 20px;\n}\n\n.btn-primary {\n  background-color: #2563eb;\n  color: white;\n  padding: 12px 24px;\n  font-size: 1rem;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.3s;\n}\n\n.btn-primary:hover {\n  background-color: #1d4ed8;\n}\n\n/* 💡 Value Section */\n.value_section {\n  display: flex;\n  justify-content: center;\n  align-items: stretch;\n  gap: 30px;\n  padding: 60px 20px;\n  background-color: #f9fafb;\n  flex-wrap: wrap;\n}\n\n.value_card {\n  background: white;\n  padding: 30px;\n  flex: 1;\n  max-width: 300px;\n  text-align: center;\n  border-radius: 12px;\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.05);\n}\n\n.value_card img {\n  height: 50px;\n  margin-bottom: 15px;\n}\n\n.value_card h4 {\n  font-size: 1.25rem;\n  margin-bottom: 10px;\n  color: #1f2937;\n}\n\n.value_card p {\n  font-size: 1rem;\n  color: #4b5563;\n}\n\n/* 👤 Testimonials Section */\n.testimonials_section {\n  background-color: #fff;\n  padding: 60px 20px;\n  text-align: center;\n}\n\n.testimonials_section h3 {\n  font-size: 2rem;\n  margin-bottom: 40px;\n  color: #1f2937;\n}\n\n.testimonial_cards {\n  display: flex;\n  gap: 30px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.testimonial_card {\n  background-color: #f3f4f6;\n  padding: 30px;\n  border-radius: 12px;\n  max-width: 300px;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.05);\n  text-align: center;\n}\n\n.testimonial_card img {\n  width: 70px;\n  height: 70px;\n  border-radius: 50%;\n  margin-bottom: 20px;\n}\n\n.testimonial_card p {\n  font-size: 1rem;\n  color: #374151;\n  margin-bottom: 10px;\n}\n\n.testimonial_card h4 {\n  font-size: 1rem;\n  font-weight: bold;\n  color: #1f2937;\n}\n\n/* 📘 About Page */\n.about_page_container {\n  background-color: #f3f4f6;\n  padding: 80px 20px 100px;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.about_content_box {\n  background-color: #ffffff;\n  padding: 40px;\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);\n  max-width: 800px;\n  text-align: center;\n}\n\n.about_content_box h1 {\n  font-size: 2.5rem;\n  color: #1f2937;\n  margin-bottom: 20px;\n}\n\n.about_content_box p {\n  font-size: 1.1rem;\n  color: #4b5563;\n  line-height: 1.8;\n  margin-bottom: 20px;\n}\n\n/* 📥 Footer */\n.footer {\n  background: linear-gradient(to right, #111827, #1f2937);\n  color: #ffffff;\n  padding: 60px 20px 30px;\n  font-size: 0.95rem;\n}\n\n.footer-columns {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 40px;\n  max-width: 1200px;\n  margin: auto;\n}\n\n.footer-about,\n.footer-contact,\n.footer-links {\n  flex: 1;\n  min-width: 250px;\n}\n\n.footer-about h3,\n.footer-contact h4,\n.footer-links h4 {\n  color: white;\n}\n\n.footer-contact p,\n.footer-about p,\n.footer-links ul {\n  margin: 5px 0;\n  color: #d1d5db;\n}\n\n.footer-contact a {\n  color: #3b82f6;\n  text-decoration: none;\n}\n\n.footer-contact a:hover {\n  text-decoration: underline;\n}\n\n.footer-links ul {\n  list-style: none;\n  padding: 0;\n}\n\n.footer-links li {\n  margin: 5px 0;\n}\n\n.footer-links a {\n  color: #9ca3af;\n  text-decoration: none;\n}\n\n.footer-links a:hover {\n  color: #ffffff;\n  text-decoration: underline;\n}\n\n.footer-bottom {\n  text-align: center;\n  padding-top: 30px;\n  border-top: 1px solid #374151;\n  color: #9ca3af;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  font-size: 0.95rem;\n}\n@media (max-width: 600px) {\n  .footer-bottom {\n    flex-direction: column;\n    gap: 4px;\n  }\n}\n\n/* 🔐 Auth Styling */\n.auth_wrapper {\n  min-height: 70vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #f9fafb;\n  padding: 40px 20px;\n}\n\n.auth_box {\n  background-color: #ffffff;\n  padding: 40px 30px;\n  border-radius: 12px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  max-width: 400px;\n  text-align: center;\n}\n\n.auth_box h2 {\n  font-size: 1.8rem;\n  margin-bottom: 20px;\n  color: #1f2937;\n}\n\n.input_group {\n  margin-bottom: 16px;\n}\n\n.input_group input {\n  width: 100%;\n  padding: 12px;\n  border-radius: 8px;\n  border: 1px solid #d1d5db;\n  font-size: 1rem;\n  transition: border-color 0.3s ease;\n}\n\n.input_group input:focus {\n  border-color: #2563eb;\n  outline: none;\n}\n\n.input_group button {\n  width: 100%;\n  padding: 12px;\n  font-size: 1rem;\n  border: none;\n  border-radius: 8px;\n  background-color: #2563eb;\n  color: white;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.input_group button:hover {\n  background-color: #1d4ed8;\n}\n\n/* 📚 Library */\n.library_wrapper {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.library_header {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 18px;\n}\n\n.library_header h2 {\n  margin: 0;\n  color: #1f2937;\n}\n\n.muted {\n  color: #6b7280;\n  margin: 6px 0 0;\n}\n\n.library_actions {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.search_box {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.search_box input {\n  height: 40px;\n  padding: 0 12px;\n  border-radius: 10px;\n  border: 1px solid #d1d5db;\n  min-width: min(420px, 78vw);\n}\n\n.btn {\n  height: 40px;\n  padding: 0 14px;\n  border: 1px solid #d1d5db;\n  background: #ffffff;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: transform 0.05s ease-in-out;\n}\n\n.btn:active {\n  transform: translateY(1px);\n}\n\n.btn-primary {\n  border: none;\n  background: #2563eb;\n  color: #ffffff;\n}\n\n.btn-danger {\n  border: 1px solid #ef4444;\n  color: #ef4444;\n  background: #fff;\n}\n\n.books_grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 16px;\n}\n\n.book-card {\n  background: #ffffff;\n  border-radius: 14px;\n  border: 1px solid #e5e7eb;\n  padding: 16px;\n  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.04);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 170px;\n}\n\n.book-meta h3 {\n  margin: 0 0 6px;\n  font-size: 1.15rem;\n  color: #111827;\n  line-height: 1.3;\n}\n\n.book-link {\n  display: inline-block;\n  margin: 10px 0 12px;\n  color: #2563eb;\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.book-actions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  margin: 18px 0 6px;\n  flex-wrap: wrap;\n}\n\n.page_meta {\n  color: #4b5563;\n}\n\n.empty_state {\n  padding: 24px;\n  border: 1px dashed #cbd5e1;\n  background: #f8fafc;\n  border-radius: 12px;\n  text-align: center;\n  color: #475569;\n}\n\n/* 🪟 Modal */\n.modal {\n  display: none;\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  z-index: 2000;\n  padding: 20px;\n}\n\n.modal-content {\n  width: min(640px, 96vw);\n  margin: 70px auto 0;\n  background: #fff;\n  border-radius: 16px;\n  padding: 22px;\n  position: relative;\n}\n\n.close-btn {\n  position: absolute;\n  top: 10px;\n  right: 14px;\n  border: none;\n  background: transparent;\n  font-size: 26px;\n  cursor: pointer;\n}\n\n.form label {\n  display: block;\n  margin: 10px 0 6px;\n  color: #374151;\n  font-weight: 600;\n}\n\n.form input,\n.form textarea {\n  width: 100%;\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  padding: 12px;\n  font-size: 1rem;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 16px;\n  flex-wrap: wrap;\n}\n\n.thumbs-container {\n  display: flex;\n  gap: 10px;\n  margin-top: 10px;\n  flex-wrap: wrap;\n}\n\n.thumb.active {\n  border-color: #2563eb;\n  background: rgba(37, 99, 235, 0.08);\n}\n\n/* 📱 Responsive Styles */\n@media (max-width: 768px) {\n  .menu-icon {\n    display: flex;\n  }\n\n  .nav_links {\n    display: none;\n    flex-direction: column;\n    position: absolute;\n    top: 50px;\n    right: 0;\n    background-color: #1f2937;\n    width: 200px;\n    padding: 15px 0;\n    border-bottom-left-radius: 12px;\n    z-index: 100;\n  }\n\n  .nav_links.active {\n    display: flex;\n  }\n\n  .fullscreen-slideshow {\n    height: 60vh;\n  }\n\n  .overlay-text {\n    font-size: 1.8rem;\n  }\n\n  .overlay_box h3 {\n    font-size: 1.5rem;\n  }\n\n  .overlay_box p {\n    font-size: 1rem;\n  }\n\n  .testimonial_cards,\n  .value_section {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .about_content_box h1 {\n    font-size: 2rem;\n  }\n\n  .about_content_box p {\n    font-size: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
